<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a" id="contents"><strong>Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/notereader#note-reader">A Note to My Readers</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">Chapter 1</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch02#ch02">Chapter 2</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch03#ch03">Chapter 3</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="tocback1"><span class="nounder" href="#/xhtml/epilogue#epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/backmatter1#backmatter1" title="Link target outside of Sample">From Sleepless in Scotland</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/backmatter2#backmatter2" title="Link target outside of Sample">From The Laird Who Loved Me</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/backmatter3#backmatter3" title="Link target outside of Sample">From One Night in Scotland</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9c612d54